module.exports = __webpack_public_path__ + "static/media/1323.2cbfddb6.jpg";